var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notifications.length)?_c('div',{class:['notifs', _vm.align]},_vm._l((_vm.notifications),function(notif){return _c('q-alert',{key:notif.id,staticClass:"alert slide-in",attrs:{"variation":notif.type},on:{"close":function($event){return _vm.removeNotif(notif.id)}}},[_vm._v(_vm._s(notif.message))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }